import React from "react";
import { Link } from "react-router-dom";

function BlogCTASection() {
  return (
    <section className="border-t border-slate-200/70 bg-white py-10 md:py-12">
      <div className="mx-auto max-w-3xl px-4 text-center">
        <h2 className="text-lg font-semibold text-slate-900 md:text-xl">Have a property or project question?</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-600 md:text-[15px]">
          Reach out for a conversation about your goals—whether you&apos;re buying, planning, or building.
        </p>
        <div className="mt-6">
          <Link
            to="/contact"
            className="inline-flex min-h-[42px] items-center justify-center rounded-md border border-slate-400/90 bg-slate-800 px-5 py-2.5 text-sm font-semibold leading-none text-white shadow-sm transition-all duration-200 hover:-translate-y-px hover:border-slate-500 hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-400"
          >
            Contact
          </Link>
        </div>
      </div>
    </section>
  );
}

export default BlogCTASection;
